
export default {
  name: 'manage-punches',
  label: 'Raw Punches',
  path: 'punches',
  link: 'punches',
  props: true,
  icon: 'business-time',
  description: 'View and edit employee punches.',
  component: () => import('@/components/TabPanel.vue'),
  requireGetter: 'canAccessManagePunches',
  breadcrumbLeaf: true,
  children: [
    {
      name: 'punch-list',
      label: 'List',
      title: 'Raw Punches',
      path: 'list/:view?',
      component: () => import('./PunchList.vue')
    },
    {
      name: 'missed-punch-list',
      label: 'Missed',
      title: 'Missed Punches',
      path: 'missed-punches/:view?',
      component: () => import('./missedpunch/MissedPunchList.vue'),
      require: state => state.enableSubmitMissedPunch
    },
    {
      name: 'manage-punches-index',
      path: '',
      redirect: { name: 'punch-list' }
    }
  ]
}
